<template>
	<div>

        <table class="hidetable" style="table-layout:fixed; display: table; float:left">
            <tr>
                <td class="hidetable" style="width:320px; max-width:320px;">
                    <div style="display:flex; align-items:center;">
                        <span style="margin-right:4px; white-space:nowrap;">Employee</span>
                        <autocomplete
                        id="employeeSearch"
                        v-model="employeeSearch"
                        :type="28"
                        :allowEmpty="true"
                        v-on:finish="setData"
                        style="flex:1; min-width:0;"
                        ></autocomplete>
                    </div>
                </td>
                <td class="hidetable" style="width:430px; max-width:430px;">
                    <div style="display:flex; align-items:center;">
                        <div class="filter-dropdown" @mouseenter="showFilterMenu = true" @mouseleave="showFilterMenu = false" style="margin-right:10px;">
                            <button style="height:30px; width:40px;">
                                <font-awesome-icon icon="filter" />
                            </button>
                            <div v-if="showFilterMenu" class="csv-menu">
                                <div @click="setFilter('payperiod')">Pay Period</div>
                                <div @click="setFilter('week')">Week</div>
                                <div @click="setFilter('custom')">Custom</div>
                            </div>
                        </div>
                        <template v-if="filterMode === 'custom'">
                            <input id="startDate" type="date" class="date" v-model="startDate" style="height:25px; flex:1; min-width:0;">
                            <span style="margin:0 4px;">–</span>
                            <input id="endDate" type="date" class="date" v-model="endDate" style="height:25px; flex:1; min-width:0;">
                        </template>
                        <select v-else :value="startDate + '|' + endDate" @change="onRangeSelect" style="flex:1; height:25px; min-width:0;">
                            <option v-for="opt in filterMode === 'week' ? weekOptions : payPeriodOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                        </select>
                    </div>
                </td>
                <td class="hidetable" style="width:100px; white-space:nowrap;">
                    <button v-on:click="search()" style="height:30px; width:40px;"><font-awesome-icon icon="search" /></button>
                    <span>Search</span>
                </td>
                <td class="hidetable" style="width:100px; white-space:nowrap;">
                    <div class="csv-dropdown" @mouseenter="showCsvMenu = true" @mouseleave="showCsvMenu = false">
                        <button style="height:30px; width:40px;">
                            <font-awesome-icon icon="download" />
                        </button>
                        <span>Download CSV</span>
                        <div v-if="showCsvMenu" class="csv-menu">
                            <div @click="download('payperiod')">Pay Period</div>
                            <div @click="download('timesheet')">Timesheet</div>
                            <div @click="download('extra')">Extra</div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>

		<layout-7
			ref="layout7"
			:id=pageid
			:term=searchTerm
			:edit_types="[null,null,null,'DateTime','DateTime',null,'TextArea','Value','Value', null]"
			:edit_perm="'99'"
			:isSelect="true"
			@select="onSelect"
			style="width:100%; height:calc(100vh - 100px);"
		></layout-7>

		<div v-if="selectedTimesheetId !== null" class="ts-overlay">
			<div class="ts-popup">
				<button class="ts-close" v-on:click="selectedTimesheetId = null"><font-awesome-icon icon="times" /></button>
				<timesheet-history 
                    :term="selectedTimesheetId"
                    :employeeid="selectedTimesheetData[0]"
                    :fromdatetime="selectedTimesheetData[1]"
                    :todatetime="selectedTimesheetData[2]"
                ></timesheet-history>
			</div>
		</div>

	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: '',
    },
	data(){
		return{
			pageid:PAGES.TIMESHEETS_B_PAGE,
			startDate:'',
			endDate:'',
			employeeSearch:'',
			showCsvMenu: false,
			showFilterMenu: false,
			filterMode: 'payperiod',
			selectedTimesheetId: null,
            selectedTimesheetData: [],
		}
	},
	mounted(){
		var q = JSON.parse(this.term);
		if(q.mode){
			this.filterMode = q.mode;
			this.startDate  = q.start || '';
			this.endDate    = q.end   || '';
			this.$nextTick(() => {
				this.employeeSearch = q.employee || '';
		        this.search();
			});
		} else {
			this.setFilter('payperiod');
		}
	},
	watch:{
		startDate(){ this.search(); this.pushRoute(); },
		endDate(){   this.search(); this.pushRoute(); },
		employeeSearch(){ this.pushRoute(); },
		filterMode(){     this.pushRoute(); },
	},
	computed:{
		searchTerm(){
			return this.employeeSearch + '||' + this.startDate + '|' + this.endDate;
		},
		payPeriodOptions(){
			var opts = [];
			var fmt  = d => d.toISOString().substring(0, 10);
			var lbl  = d => { var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; return mo[d.getMonth()] + ' ' + d.getDate(); };
			var today = new Date(); today.setHours(0,0,0,0);
			var cutoff = new Date(today); cutoff.setMonth(cutoff.getMonth() - 2);
			var ref = new Date(today.getFullYear(), 0, 5);
			var s = new Date(ref);
			while(s <= today){
				var e = new Date(s); e.setDate(s.getDate() + 13);
				if(e >= cutoff) opts.unshift({ label: lbl(s) + ' – ' + lbl(e), value: fmt(s) + '|' + fmt(e) });
				s = new Date(e); s.setDate(e.getDate() + 1);
			}
			return opts;
		},
		weekOptions(){
			var opts = [];
			var fmt  = d => d.toISOString().substring(0, 10);
			var lbl  = d => { var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; return mo[d.getMonth()] + ' ' + d.getDate(); };
			var today = new Date(); today.setHours(0,0,0,0);
			var cutoff = new Date(today); cutoff.setMonth(cutoff.getMonth() - 2);
			var day = today.getDay();
			var mon = new Date(today); mon.setDate(today.getDate() - ((day + 6) % 7));
			var s = new Date(mon);
			while(s >= cutoff){ s.setDate(s.getDate() - 7); }
			s.setDate(s.getDate() + 7);
			while(s <= mon){
				var sun = new Date(s); sun.setDate(s.getDate() + 6);
				opts.unshift({ label: lbl(s) + ' – ' + lbl(sun), value: fmt(s) + '|' + fmt(sun) });
				s = new Date(s); s.setDate(s.getDate() + 7);
			}
			return opts;
		},
	},
	methods:{
		setFilter(mode){
			this.filterMode = mode;
			this.showFilterMenu = false;
			if(mode === 'custom'){
				this.startDate = '';
				this.endDate   = '';
			} else {
				var opts = mode === 'week' ? this.weekOptions : this.payPeriodOptions;
				if(opts.length){
					var parts = opts[0].value.split('|');
					this.startDate = parts[0];
					this.endDate   = parts[1];
				}
			}
		},
		pushRoute(){
			var q = { mode: this.filterMode, start: this.startDate, end: this.endDate };
			if(this.employeeSearch) q.employee = this.employeeSearch;
			router.replace('0326?q='+JSON.stringify(q));
		},
		onRangeSelect(e){
			var parts = e.target.value.split('|');
			this.startDate = parts[0];
			this.endDate   = parts[1];
		},
		onSelect(row){
			this.selectedTimesheetId = row[0];
			this.selectedTimesheetData = [row[1], row[3], row[4]];
		},
		search(){
			this.$refs.layout7.getTables();
		},
		setData(index, content){
			this.employeeSearch = content;
			this.$nextTick(() => {
				this.$refs.layout7.getTables();
			});
		},
		download(csvrequest){
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:this.pageid,
                        data:[
                            this.employeeSearch,
                            this.startDate + '|' + this.endDate
                        ],
                        csvrequest:csvrequest,
                    }
                }
            ).then((res) => {
                var employeeName = this.employeeSearch.includes('• ')
                    ? this.employeeSearch.split('• ')[1]
                    : this.employeeSearch;
                var base = employeeName || 'All';
                var filename;
                switch(csvrequest){
                    case 'payperiod': filename = base + ' - Hours.csv'; break;
                    case 'timesheet': filename = base + ' - Timesheet.csv'; break;
                    case 'extra':     filename = base + ' - Extra.csv';     break;
                    default:          filename = base + ' - Hours.csv';
                }

                var blob = new Blob([res.data.csvdata], { type: 'text/csv' });
                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                URL.revokeObjectURL(url);
            })
		}
	}
}
</script>

<style scoped>
.filter-dropdown {
    position: relative;
    display: inline-block;
}
.csv-dropdown {
    position: relative;
    display: inline-block;
}
.csv-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background: #fff;
    border: 1px solid #ccc;
    z-index: 100;
    min-width: 120px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}
.csv-menu div {
    padding: 6px 12px;
    cursor: pointer;
    white-space: nowrap;
}
.csv-menu div:hover {
    background: #f0f0f0;
}
.hidetable{
	table-layout:fixed;
	background-color: #ffffff;
	border-collapse: collapse;
	border: 0px solid black;
	empty-cells: show;
}
.ts-overlay {
	position: fixed;
	top: 0; left: 0;
	width: 100%; height: 100%;
	background: rgba(0,0,0,0.5);
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: center;
}
.ts-popup {
	background: #fff;
	border-radius: 4px;
	padding: 32px;
	width: 99vw;
	max-width: 99vw;
	max-height: 90vh;
	overflow-y: auto;
	position: relative;
}
.ts-close {
	position: absolute;
	top: 8px;
	right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/Timesheets.vue